// import { IonModal } from '@ionic/react';
import React, { useEffect, useRef, useState } from 'react';
import Tree from 'react-d3-tree';
import OptionModal from '../Modal/OptionModal';
import './Tree.scss';

const renderForeignObjectNode = ({
  nodeDatum,
  toggleNode,
  foreignObjectProps,
  setProcessGoal,
  setOption,
}) => {
  const hasChildren = nodeDatum?.children;
  const isCollapsed = nodeDatum.__rd3t.collapsed && nodeDatum.__rd3t.depth > 0;
  const btnStyle = {
    borderRadius: '25px',
    background: hasChildren && !isCollapsed ? '#501AA6' : '#FFFFFF',
    color: hasChildren && !isCollapsed ? '#FFFFFF' : '#222222',
    fontSize: '12px',
    padding: '8px',
    boxShadow: '0 10px 6px -6px rgba(122,122,122,0.26)',
    fontFamily: 'HelveticaRegular',
  };

  /* eslint-disable */
  return (
    <g>
      <foreignObject {...foreignObjectProps}>
        <button
          id={`onNodeClick-${nodeDatum.itemId}`}
          type="button"
          style={btnStyle}
          onClick={() => {
            toggleNode();
            if (nodeDatum.__rd3t.depth < 2) {
              setProcessGoal(nodeDatum);
            } else {
              setOption(nodeDatum);
            }
          }}
        >
          {nodeDatum.name?.replace('<br>', ' ')}
        </button>
      </foreignObject>
    </g>
  );
  /* eslint-enable */
};

// eslint-disable-next-line
export default function TreeChart({ processGoal, screenSize, initialDepth, setProcessGoal, zoomlevel }) {
  const [data, setData] = useState({});
  const [width, setWidth] = React.useState(0);
  const [height, setHeight] = React.useState(0);
  const [option, setOption] = useState(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [depthFactor, setDepthFactor] = useState(0);
  const treeRef = useRef();
  const nodeSize = { x: 125, y: 125 };
  const foreignObjectProps = { width: nodeSize.x, height: nodeSize.y, x: 0, y: -16 };

  // handles json to render
  useEffect(() => {
    if (processGoal) {
      const stringified = processGoal && JSON.stringify(processGoal);
      const setToChildren = stringified && stringified.replace(/"decisionPoints":/gm, '"children":').replace(/"options":/gm, '"children":');
      setData(setToChildren && JSON.parse(setToChildren));
    }
  }, [processGoal, initialDepth, zoomlevel]);

  // handles depth factor according to screensize
  useEffect(() => {
    if (screenSize < 500) {
      setDepthFactor(200);
    } else if (screenSize < 600) {
      setDepthFactor(240);
    } else if (screenSize < 800) {
      setDepthFactor(280);
    } else {
      setDepthFactor(360);
    }
  }, [screenSize]);

  // handles centering of nodes when clicked
  useEffect(() => {
    setTimeout(() => setWidth(treeRef.current.getBoundingClientRect().width - 125), 100);
    setTimeout(() => setHeight(treeRef.current.getBoundingClientRect().height), 100);
    setTimeout(() => setDimensions({ width, height }), 100);
  }, [width, height]);

  return (
    <div style={{ height: '400px' }} ref={treeRef}>
      <OptionModal option={option} setOption={setOption} />
      <Tree
        data={data}
        translate={{ x: 30, y: 200 }}
        dimensions={dimensions}
        initialDepth={initialDepth}
        zoom={zoomlevel}
        nodeSize={nodeSize}
        separation={{ siblings: 0.72, nonSiblings: 0.4 }}
        depthFactor={depthFactor}
        renderCustomNodeElement={(rd3tProps) => renderForeignObjectNode({ ...rd3tProps, foreignObjectProps, setProcessGoal, setOption })}
        shouldCollapseNeighborNodes
      />
    </div>
  );
}
